export default __webpack_public_path__ + "27ce5af2f69b956d2ba2a16be7fbe1df.png";